import React, { useState } from "react";
import {
  Row,
  Col,
  Spin,
  Form,
  Card,
  InputNumber,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { rightAction } from "../../../../redux/actions";
import {
  labelConfig,
  staticConfig,
  apiConfig,
} from "../../treasuryContractBooking.config";
import { BOM } from "../../../../services/definedMethod";

const AddAuctionLine = (props) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams(); // auctionId

  const onFinish = async (values) => {
    try {
      setIsLoading(true);

      const payload = {
        tenor: values.tenor,
        amountOffered: values.amountOffered,
      };

      // await BOM.SendReq(apiConfig.addAuctionLine, { auctionId: id, ...payload });
      console.log("AddAuctionLine payload:", payload);
      BOM.AlertMsg(cnt.SUCCESS, "Auction line added successfully.");
      navigate(-1);
    } catch (error) {
      BOM.AlertMsg(cnt.DANGER, error?.message || "Failed to add auction line.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MainLayout pageItems={staticConfig.newAuction}>
      <TopContent pageTitle={labelConfig.securityProduct} />

      <Spin spinning={isLoading} size="large">
        <div style={{ padding: "24px" }}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            <h3 style={{ marginBottom: 24, fontWeight: 600 }}>
              Add Auction Line
            </h3>

            <Form layout="vertical" form={form} onFinish={onFinish}>

              <Row>
                {/* Tenor */}
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Tenor (Days)
                        <Tooltip title="The number of days to maturity for this auction line.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="tenor"
                    rules={[
                      { required: true, message: "Tenor is required" },
                      { type: "number", min: 1, message: "Tenor must be at least 1 day" },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%", height: 44 }}
                      placeholder="e.g. 91"
                      min={1}
                      precision={0}
                    />
                  </Form.Item>
                </Col>

                {/* Amount Offered */}
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Amount Offered
                        <Tooltip title="The face value amount offered for this tenor line.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="amountOffered"
                    rules={[
                      { required: true, message: "Amount offered is required" },
                      { type: "number", min: 1, message: "Amount must be greater than 0" },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%", height: 44 }}
                      placeholder="e.g. 500,000,000.00"
                      formatter={(value) =>
                        value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
                      }
                      parser={(value) => value?.replace(/,/g, "")}
                      precision={2}
                      min={0}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Divider */}
              <div style={{ borderTop: "1px solid #EAECF0", margin: "8px 0 20px" }} />

              {/* Action Buttons */}
              <Row justify="end">
                <Col>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      color: "#344054",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                      marginRight: 12,
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => form.submit()}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #BA24D5",
                      background: "#BA24D5",
                      color: "#fff",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                    }}
                  >
                    Submit
                  </button>
                </Col>
              </Row>

              <button type="submit" hidden />
            </Form>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, { rightAction })(AddAuctionLine);